<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="closeForm"
    :title="rowInfo.id===''?'添加员工':'编辑员工'"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="empName">
              <el-input v-model="rowInfo.empName" placeholder="姓名" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="rowInfo.idCard" placeholder="身份证号" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="12">
            <el-form-item label="性别" prop="gender">
              <select-text v-model="rowInfo.gender" code-set-id="1001" placeholder="性别" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生日期" prop="birthday">
               <el-date-picker
                 v-model="rowInfo.birthday"
                 type="date"
                 placeholder="出生日期"
                 value-format="yyyy-MM-dd"
                 style="width: 220px">
                </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="rowInfo.phone" placeholder="电话" style="width: 220px"/>
            </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="rowInfo.email" placeholder="邮箱" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属部门" prop="dept">
              <el-input v-model="rowInfo.dept" placeholder="所属部门" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="员工照片">
                <img-upload
                  v-model="rowInfo.photo"
                  :url="rowInfo.photoUrl"
                />
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                :autosize="{ minRows: 3, maxRows: 5}"
                v-model="rowInfo.remark"
                placeholder="备注"
                type="textarea"
                resize = "none"
                style="width:90%;"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import SelectText from '@/components/SelectText/index.vue'
  import ImgUpload from '@/components/ImgUpload/index.vue'
  import { addListpage,getDynamicFormValue } from  "@/api/cus/empinfo"
  import { mapGetters } from 'vuex';
  export default {
    components: {
      SelectText,ImgUpload
    },
    computed: {
      headers() {
        return {
          Authorization: `Bearer ${this.accessToken}`,
        };
      },
      ...mapGetters(['accessToken'])
    },
    data() {
      // 手机号
      let validatePhone = (rule, value, callback) => {
        let isNum = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (value && !isNum.test(value)) {
          callback(new Error('请输入正确的电话'))
        }
        callback()
      }
      let validateEmail = (rule, value, callback) => {
        let isNum = /^\w+([-+.]\w+)*@\w+([-.]\w+)*.\w+([-.]\w+)*$/
        if (value && !isNum.test(value)) {
          callback(new Error('请输入正确的邮箱'))
        }
        callback()
      }
      let validateIdCard = (rule, value, callback) => {
        let isNum = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (value && !isNum.test(value)) {
          callback(new Error('请输入正确的身份证号'))
        }
        callback()
      }
      return {
        visible: false,
        formName: '新增',
        uploadUrl: process.env.VUE_APP_BASE_API + '/attach/upload',
        loading: false,
        rowInfo: {
          id: '',
          empName: '',
          idCard: '',
          gender: '',
          birthday: '',
          phone: '',
          email: '',
          photo: '',
          photoUrl: '',
          remark: '',
          status: '1'
        },
        rules: {
          empName: [{ required: true, message: '必填:姓名', trigger: 'blur' }],
          idCard: [
            { required: true, message: '必填:身份证号', trigger: 'blur' },
            { validator: validateIdCard, trigger: 'blur' }
          ],
          gender: [{ required: true, message: '必填:性别', trigger: 'change' }],
          birthday: [{ required: true, message: '必填:性别', trigger: 'change' }],
          phone: [
            { required: true, message: '必填:电话', trigger: 'blur' },
            { validator: validatePhone, trigger: 'blur' }
          ],
          email: [
            { validator: validateEmail, trigger: 'blur' }
          ]
        }
      }
    },
    mounted() {
    },
    methods: {
      init(id) {
        this.visible = true
        this.rowInfo.id = id
        if (id) {
          getDynamicFormValue(id).then((res) => {
            if(res.data.code==0){
              let data = res.data
              this.rowInfo = data.data
            }
          })
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            addListpage(this.rowInfo).then((res) => {
              if (res.data.code==0) {
                // 在store中改变修改的值
                if (this.rowInfo.id) {
                  this.$message.success("编辑成功")
                } else {
                  this.$message.success("添加成功")
                }
                // 子组件中触发父组件的初始化方法
                this.$emit('refresh', '')
                // 关闭弹框
                this.closeForm()
              }
            })
          } else {
            return false
          }
        })
      },
      closeForm() {
        this.visible = false
        // 重置表单
        this.$refs['rowInfo'].resetFields()
        this.rowInfo = {
          id: '',
          empName: '',
          idCard: '',
          gender: '',
          birthday: '',
          phone: '',
          email: '',
          photo: '',
          photoUrl: '',
          remark: '',
          status: '1'
        }
      }
    }
  }
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
